<template>
    <div class="img-model" @click="closeImg">
        <img :src="imgSrc" @click="closeImg">
        <!-- <img src="@/assets/img/picTest/1.jpg" @click="closeImg"> -->
    </div>
</template>
<script>
export default {
    props:{
        imgSrc:{
            type: String,
        }
    },
    data() {
        return {

        }
    },
    methods:{
        closeImg() {
            this.$emit('closeImg');
        }
    }
}
</script>
<style lang="less" scoped>
.img-model{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.8);
    width: 100%;
    height: 100%;
    img{
        position: absolute;
        left: 0;
        top: 2rem;
        // transform: translateY(-50%);
        @media screen and (orientation : portrait){
            width: 100%;
        }
        @media screen and (orientation : landscape){
            max-height: 4.5rem;
            height:100%;
            left:50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
</style>
